export default "__VITE_ASSET__sxF7eR7T__"